import styled from 'styled-components';

export const StyledInput = styled.input`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  padding: 12px 16px;
  margin: 8px 0;
  border: 1px solid #61cbc9;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: border-color 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease;
  color: #333333;

  &::placeholder {
    color: #8c8c8c;
    font-size: 14px;
  }

  &:hover {
    border-color: rgba(97, 203, 201, 0.5);
    background-color: #ffffff;
  }

  &:focus {
    border-color: rgba(97, 203, 201, 1);
    outline: none;
    box-shadow: 0 0 0 2px rgba(97, 203, 201, 0.3);
  }

  &:disabled {
    background-color: rgba(97, 203, 201, 0.2);
    border-color: rgba(97, 203, 201, 1);
    color: #a6a6a6;
    cursor: not-allowed;
  }

  ${({ isFilled }) =>
    isFilled &&
    `
      background-color: #e6faf9;
      border-color: #61cbc9;
      color: #333333;
    `}

  ${({ isError }) =>
    isError &&
    `
      border-color: rgba(255, 102, 0, 1);
      background-color: rgba(255, 102, 0, 0.1);
      color: #a6a6a6;
    `}

  ${({ isError, value }) =>
    isError &&
    value === '' &&
    `
      border-color: rgba(255, 102, 0, 1);
      background-color: #fff5f5;
      color: #ff4d4f;
    `}
`;
